<template>
  <div class="app-voucher-page">
    <el-form ref="appForm"
             class="form-content form-error-right"
             label-position="left"
             label-width="120px">
      <el-form-item label="app_key" prop="area_name">
        <span>{{appKey || '--'}}</span>
      </el-form-item>
      <el-form-item label="app_secret" prop="area_name">
        <span>{{appSecret || '--'}}</span>
        <span class="opt-btn" @click="resetSecret">重置</span>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'controlAppVoucher',
    data() {
      return {
        appId: '',
        appStatus: '',
        appKey: '',
        appSecret: ''
      }
    },
    mounted() {
      this.appId = this.$route.params.appId
      this.getDetail()
    },
    methods: {
      // 获取详情
      getDetail() {
        this.server.post("/ajax/control/panel/app/info", {
          app_id: this.appId
        }).then(res => {
          let detail = res.data.data;
          this.appStatus = detail.status;
          this.appKey = detail.app_key;
          this.appSecret = detail.app_secret;
        });
      },
      // 重置app_secret
      resetSecret() {
        if(this.isLoading) {
          return
        }
        this.$confirm('确定重置 app_secret 的值？', '', {
          confirmButtonText: '确 定',
          cancelButtonText: '取 消',
          type: 'warning',
          showClose: false,
        }).then(() => {
          this.showCommonLoading();
          this.server.post("/ajax/control/panel/app/secret/reset", {
            app_id: this.appId
          }).then(res => {
            this.hideCommonLoading();
            this.appSecret = res.data.data.app_secret;
          }).catch(e => {
            this.hideCommonLoading();
          });
        }).catch(() => {});
      },
    }
  }
</script>

<style lang="scss">
  .app-voucher-page {
    .form-content {
      .el-form-item {
        margin-bottom: 8px;
      }
      .el-form-item__label {
        padding-right: 34px;
        font-size: 16px;
      }
      .el-form-item__content {
        font-size: 16px;
        color: #666;
      }
    }
  }
</style>
<style lang="scss" scoped>
  .app-voucher-page {
    padding: 65px 0 30px;
    box-sizing: border-box;
    .form-content {
      width: 520px;
      margin-left: 180px;
      .opt-btn {
        display: inline-block;
        width: 40px;
        height: 16px;
        line-height: 14px;
        font-size: 12px;
        color: #F16222;
        text-align: center;
        border-radius: 10px;
        margin-left: 7px;
        border: 1px solid rgba(241, 98, 34, 1);
        cursor: pointer;
        transform: scale(0.9);
        transform-origin: top;
        position: relative;
        top: -1px;
      }
    }
    .title {
      font-size: 16px;
      margin-bottom: 20px;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/control/app/voucher.vue